import React, { FC, ReactNode } from "react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      className={`nc-SectionHero relative ${className} `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left mt-24 lg:mt-0">
        <div className="flex-grow">
          <img className="w-full" src={rightImg} alt="" />
        </div>
        <div className="w-screen max-w-full  space-y-5 lg:space-y-7">
          <p className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 ">
            <span>{heading}</span>
          </p>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            {subHeading}
            <span></span>
          </span>
          {/* <div className="bg-[#F5F5F7] py-5 px-2 rounded-lg">
            <div className="flex flex-row gap-4  text-left">
              <div>
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1258 14.8599V10.6606H23.2273V14.8599H19.1258ZM9.36016 32.9263C12.6805 36.1815 16.6193 37.8091 21.1766 37.8091C25.7339 37.8091 29.6401 36.1815 32.8953 32.9263C36.2156 29.606 37.8758 25.6672 37.8758 21.1099C37.8758 16.5526 36.2156 12.6463 32.8953 9.39111C29.6401 6.0708 25.7339 4.41064 21.1766 4.41064C16.6193 4.41064 12.6805 6.0708 9.36016 9.39111C6.10495 12.6463 4.47734 16.5526 4.47734 21.1099C4.47734 25.6672 6.10495 29.606 9.36016 32.9263ZM6.43047 6.46143C10.532 2.35986 15.4474 0.309082 21.1766 0.309082C26.9057 0.309082 31.7885 2.35986 35.825 6.46143C39.9266 10.4979 41.9773 15.3807 41.9773 21.1099C41.9773 26.839 39.9266 31.7544 35.825 35.856C31.7885 39.8924 26.9057 41.9106 21.1766 41.9106C15.4474 41.9106 10.532 39.8924 6.43047 35.856C2.39401 31.7544 0.375782 26.839 0.375782 21.1099C0.375782 15.3807 2.39401 10.4979 6.43047 6.46143ZM19.1258 31.5591V19.0591H23.2273V31.5591H19.1258Z"
                    fill="#F4A84A"
                  />
                </svg>
              </div>
              <div>
                <span className="text-[#54595F] font-semibold">
                  Information
                </span>
                <br />
                <span className="text-[#54595F] !pointer-events-autotext-left">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
                  leo.
                </span>
              </div>
            </div>
          </div> */}
          {location.pathname === "/" && (
            <ButtonPrimary onClick={() => navigate("/about")}>
              Read More
            </ButtonPrimary>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
